export default () => ({

    filters: {
        join: [],
        type: [],
        mood: [],
        time: [],
        when: [],
    },

    default_filters: {
        join: [],
        type: [],
        mood: [],
        time: [],
        when: [],
    },

    state: {

        // Флаг изменения активной записи истории
        from_popstate: false,

        // Язык
        lang: 'ru',

        // Заголовки со склонениями
        lang_titles: '',

        // Заголовки со склонениями
        lang_save: '',

        // Базовый URL запроса, добавляется перед маршрутом
        base_url: '',

        // Маршрут запроса
        route: '',

        // Даты для фильтра
        dates: {
            week: '',
            month: '',
            twoMonths: '',
        },

        form_caption: '',
    },

    events: [],

    selected_events: [],

    init() {
        this.initState();
        this.initEvents();
        this.initFilters();

        this.handlePopState();

        // noinspection JSUnresolvedReference
        this.$watch('selected_events', () => {
            Alpine.store('global').suggested_events = this.selected_events.map(event => event.id)
        });
    },

    initState() {

        // noinspection JSUnresolvedReference
        this.state.lang = this.$root.getAttribute('data-lang');

        // noinspection JSUnresolvedReference
        this.state.lang_titles = this.$root.getAttribute('data-lang-titles');

        // noinspection JSUnresolvedReference
        this.state.lang_save = this.$root.getAttribute('data-lang-save');

        // noinspection JSUnresolvedReference
        this.state.base_url = this.$root.getAttribute('data-base-url').replace(/\/$/, '');

        // noinspection JSUnresolvedReference
        this.state.route = this.$root.getAttribute('data-route').replace(/\/$/, '');

        // noinspection JSUnresolvedReference
        this.state.dates.week = this.$root.dataset.week;

        // noinspection JSUnresolvedReference
        this.state.dates.month = this.$root.dataset.month;

        // noinspection JSUnresolvedReference
        this.state.dates.twoMonths = this.$root.dataset.twoMonths;
    },

    initEvents() {

        // noinspection JSUnresolvedReference
        this.events = JSON.parse(this.$root.dataset.events);

        this.events.forEach(event => {
            event.is_card_loaded = false;
            event.card_html      = '';
        });
    },

    initFilters() {

        // noinspection JSUnresolvedReference
        this.$watch('filters', () => {
            this.updateSelectedEvents();
        });

        Alpine.nextTick().then(() => {
            Alpine.nextTick().then(() => {
                // noinspection JSUnresolvedReference,JSUnusedLocalSymbols
                this.$watch('filters', (value, oldValue) => {

                    // history

                    let searchParamsData = this.getSearchParamsData()

                    const historySearchParams = new URLSearchParams(searchParamsData).toString().replace(/%2C/g, ',');

                    if (!this.state.from_popstate) {

                        const data = JSON.parse(JSON.stringify(this.filters));

                        const url = this.state.base_url + this.state.route + '?' + historySearchParams;

                        history.pushState(data, window.title, url);
                    }
                })
            });
        });

        // noinspection JSUnresolvedReference
        this.$watch('selected_events', () => {
            this.updateFormCaption();
        });
    },

    getSearchParamsData() {

        let data = {}

        //  В театр я пойду с…
        const join_with = this.filters.join.join(',');

        if (join_with.length) {
            data.join = join_with;
        }

        // Мне по душе…
        const type = this.filters.type.join(',');

        if (type.length) {
            data.type = type;
        }

        // Хочу, чтобы вечер был…
        const mood = this.filters.mood.join(',');

        if (mood.length) {
            data.mood = mood;
        }

        // Продолжительность
        const time = this.filters.time
            .filter(value => value !== 'any').join(',');

        if (time.length) {
            data.time = time;
        }

        // Собираюсь в театр…
        const when = this.filters.when.join(',');

        if (when.length) {
            data.when = when;
        }

        return data;
    },

    updateSelectedEvents() {

        this.selected_events = this.events.filter((event) => {

            let hasFeatured = this.events.some(evt => evt.featured);

            // Нет активных фильтров?
            if (!this.hasActiveFilters() && hasFeatured) {
                return event.featured;
            }

            // В театр я пойду с…
            if (this.filters.join.length) {

                let found = false;

                this.filters.join.forEach((option_value) => {

                    // noinspection JSUnresolvedReference
                    let variants = event.join_with.split(',');

                    found = found || variants.some((variant) => {
                        return variant === option_value;
                    });
                });

                if (!found) {
                    return false;
                }
            }

            // Мне по душе…
            if (this.filters.type.length) {

                let found = false;

                this.filters.type.forEach((option_value) => {

                    let variants = event.type.split(',');

                    found = found || variants.some((variant) => {
                        return variant === option_value;
                    });
                });

                if (!found) {
                    return false;
                }
            }

            // Хочу, чтобы вечер был…
            if (this.filters.mood.length) {

                let found = false;

                this.filters.mood.forEach((option_value) => {

                    let variants = event.mood.split(',');

                    found = found || variants.some((variant) => {
                        return variant === option_value;
                    });
                });

                if (!found) {
                    return false;
                }
            }

            // Продолжительность
            if (this.filters.time.length) {

                let found = false;

                this.filters.time.forEach((option_value) => {

                    if (option_value === 'any') {
                        found = true;
                    }

                    if (option_value === '2h' && event.duration <= 120) {
                        found = true
                    }

                    if (option_value === '3h' && event.duration <= 180) {
                        found = true;
                    }
                });

                if (!found) {
                    return false;
                }
            }

            // Собираюсь в театр…
            if (this.filters.when.length) {

                let found = false;

                this.filters.when.forEach((option_value) => {

                    let event_dates = event.date.split(',');

                    if (option_value === 'week' && event_dates.some(date => date <= this.state.dates.week)) {
                        found = true;
                    }

                    if (option_value === 'month' && event_dates.some(date => date <= this.state.dates.month)) {
                        found = true;
                    }

                    if (option_value === '2months' && event_dates.some(date => date <= this.state.dates.twoMonths)) {
                        found = true;
                    }
                });

                if (!found) {
                    return false;
                }
            }

            return true;
        });
    },

    handlePopState() {

        // Обработчик события изменения URL
        window.addEventListener('popstate', (event) => {

            this.state.from_popstate = true;

            this.state.page = 1;

            for (let key in this.filters) {
                if (this.default_filters.hasOwnProperty(key)) {
                    this.filters[key] = this.default_filters[key];
                }
            }

            if (event.state) {
                for (let key in this.filters) {
                    if (event.state.hasOwnProperty(key)) {
                        this.filters[key] = event.state[key];
                    }
                }
            }
        });
    },

    load_event_card(event) {

        if (event.is_card_loaded) {
            return;
        }

        let route = window["yep_ajax"].url;

        // Параметры запроса
        let searchParamsData = {};

        searchParamsData.event_id = event.id;

        searchParamsData.action = 'suggestion_card_html';

        searchParamsData.lang = this.state.lang;

        // noinspection JSCheckFunctionSignatures
        axios.get(route, {

            baseURL: this.state.base_url,

            params: searchParamsData,

            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },

        }).then(response => {

            let event1 = this.events.find(evt => evt.id === event.id);

            let event2 = this.selected_events.find(evt => evt.id === event.id);

            if (typeof event1 === 'object') {
                event1.is_card_loaded = true;
                event1.card_html      = response.data.content;
            }

            if (typeof event2 === 'object') {
                event2.is_card_loaded = true;
                event2.card_html      = response.data.content;
            }

        }).catch(error => {

            console.error(error);

        }).finally(() => {

        });
    },

    hasActiveFilters() {

        return this.filters.join.length
            || this.filters.type.length
            || this.filters.mood.length
            || (this.filters.time.length && this.filters.time[0] !== 'any')
            || this.filters.when.length
    },

    getSelectedEventsTitle() {

        const n = this.selected_events.length;

        let titles = this.state.lang_titles.split('|');
        let title  = '';

        if (this.state.lang === 'ru') {
            const cases = [2, 0, 1, 1, 1, 2];
            title       = titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
        } else {
            if (n === 1) {
                title = titles[0];
            } else {
                title = titles[1];
            }
        }

        return title.replace(/%d/g, n.toString());
    },

    getSaveToEmailText() {

        const n = this.selected_events.length;

        let titles = this.state.lang_save.split('|');
        let title  = '';

        if (this.state.lang === 'ru') {
            const cases = [2, 0, 1, 1, 1, 2];
            title       = titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
        } else {
            if (n === 1) {
                title = titles[0];
            } else {
                title = titles[1];
            }
        }

        return title.replace(/%d/g, n.toString());
    },

    updateFormCaption(){
        this.state.form_caption = this.getSaveToEmailText();
    }

});